
import { CourseTemplateCard } from "./CourseTemplateCard";
import { Skeleton } from "@/components/ui/skeleton";

interface CourseTemplate {
  id: string;
  title: string;
  description: string | null;
  preview_image_url: string | null;
  topic: string;
  company: string;
  primary_color: string;
  secondary_color: string;
}

interface CourseTemplateGridProps {
  templates: CourseTemplate[] | undefined;
  isLoading: boolean;
  onSelect: (template: CourseTemplate) => void;
  disabled: boolean;
}

export function CourseTemplateGrid({ 
  templates, 
  isLoading, 
  onSelect, 
  disabled 
}: CourseTemplateGridProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {[1, 2, 3].map((i) => (
          <div key={i} className="space-y-3">
            <Skeleton className="h-[200px] w-full" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-4 w-1/2" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {templates?.map((template) => (
        <CourseTemplateCard
          key={template.id}
          template={template}
          onSelect={() => onSelect(template)}
          disabled={disabled}
        />
      ))}
    </div>
  );
}
